<template>
  <el-form-item class="security_numbers_comp">
    <template v-for="(n, i) in securityNumber.numberLength" :key="i">
      <el-input
        type="tel"
        pattern="\d*"
        :ref="(el) => (inputs[i] = el)"
        v-model="securityNumber.inputsValue[i]"
        autocomplete="off"
        @input="onInput($event, i)"
      ></el-input>
      <template v-for="(space, key) in spaces" :key="key">
        <span v-if="n == space" class="mx-2"></span>
      </template>
      <template v-for="(dash, key) in dashes" :key="key">
        <span v-if="n == dash" class="ml-2 mr-2 d-flex align-items-center p-10">-</span>
      </template>
    </template>
  </el-form-item>
</template>

<script>
import { inject } from "vue";

export default {
  components: {},
  props: {
    spaces: {
      type: Object,
      default: () => ({}),
    },
    dashes: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
    console.log("created", this.spacing);
  },
  setup() {
    const checkFormValidation = inject("checkFormValidation");
    const formsRefs = inject("formsRefs");
    const securityNumber = inject("securityNumber");
    const goNext = inject("goNext");
    const inputs = [];

    const getCode = () => {
      return securityNumber.inputsValue.join("");
    };
    const getNextInput = (index) => {
      if (index >= inputs.length) return undefined;
      return inputs[index + 1];
    };
    const handlePaste = (value, index) => {
      if (value.length >= inputs.length) index = 0;

      value.split("").map((char, charIndex) => {
        console.log(char, index + charIndex);
        const inputIndex = index + charIndex;
        if (inputIndex < inputs.length) securityNumber.inputsValue[inputIndex] = char;
      });
    };
    const onInput = (value, index) => {
      const isFilled = value.length > 0;
      
      
      if (!isFilled) return;
      
      if (!/^[0-9]$/.test(value)) {
        securityNumber.inputsValue[index] = ""; // Clear the invalid input
        return;
      }

      if(isNaN(value)) return

      if (value.length > 1) {
        handlePaste(value, index);
      } else {
        const nextInput = getNextInput(index);
        if (nextInput) nextInput.focus();
      }

      const code = getCode();
      securityNumber.value = code;
    };
    return {
      securityNumber,
      inputs,
      checkFormValidation,
      formsRefs,
      goNext,
      getCode,
      getNextInput,
      handlePaste,
      onInput,
    };
  },
};
</script>
